import React from 'react';

const Description = () => (
    <>
        <p>Welcome to Custom Fields Suite 👋</p>
        <p>
            As you’re here, we bet you need advanced custom fields to empower your teams’ workflow. 🚀 In this app, you can use
            three custom fields: Multilevel Select, Regular Expression, and Dynamic field.
        </p>
        <p>👀 Let’s see step-by-step how they work and how they can benefit you.</p>
        <p>
            <strong>Remember</strong>
        </p>
        <ul>
            <li>All advanced custom fields also work for service projects.</li>
            <li>Visit documentation if you need a deeper dive.</li>
        </ul>
    </>
);

export default Description;
